import React from "react";
import { Button, Grid } from "semantic-ui-react";
import useCustomerView from "../../hooks/useCustomerView";
import ExpandButton from "@buttons/ExpandButton";

const CustomerViewsFilters = () => {
  const {
    selectedCustomer,
    activeViewTab,
    hideViewTab,
    onViewClick,
    setState,
    tabOptions,
  } = useCustomerView();

  return (
    <Grid className="p-1">
      <Grid.Row className="flex-row-center">
        {activeViewTab && (
          <ExpandButton
            content={hideViewTab ? "Show Tab" : "Hide Tab"}
            compact={false}
            onClick={() => setState({ hideViewTab: !hideViewTab })}
          />
        )}
        {selectedCustomer &&
          tabOptions.map((x) => {
            return (
              <Button
                key={x.value}
                primary={activeViewTab === x.value}
                onClick={() =>
                  onViewClick({ activeViewTab: x.value, selectedCustomer })
                }
              >
                <span>{x.text}</span>
              </Button>
            );
          })}
      </Grid.Row>
    </Grid>
  );
};

export default CustomerViewsFilters;
